class StoreService {
  storage = window.localStorage;

  key = '';

  version = 'v3';

  constructor(key) {
    this.key = key;
  }

  saveOrUpdate = value => {
    this.storage.setItem(`${this.version}_${this.key}`, value);
  };

  get = () => {
    return this.storage.getItem(`${this.version}_${this.key}`);
  };

  remove = () => {
    this.storage.removeItem(`${this.version}_${this.key}`);
  };
}

export default StoreService;
